import { TrafficLayer } from '@chr/online-shared-ui-maps';
import { useTrackingMap } from './TrackingMapProvider';

export const TrackingMapTrafficLayer = () => {
    const { isTrafficEnabled } = useTrackingMap();

    return (
        <TrafficLayer enabled={isTrafficEnabled} data-testid="traffic-layer" />
    );
};